import { Grid, Typography } from '@mui/material';
import styles from '../Information.module.scss'
import GridTableComponent from '../../common/GridTableComponent/gridTableTemplate';


const AbishekaSponsorship = () => {
    const TableAbishekam = [
        {
            "Abhishekam to": "Venkateshwara (Balaji/Vishnu)",
            "Abhishekam at": "Saturday 10 am"
        },
        {
            "Abhishekam to": "Shiva",
            "Abhishekam at": "Daily 9:30"
        },
        {
            "Abhishekam to": "Ganesha (Ganapathi)",
            "Abhishekam at": "Sunday 10 am"
        },
        {
            "Abhishekam to": "Karthikeya (Murugan/Subramanya)",
            "Abhishekam at": "Sunday 11:30 am"
        },
        {
            "Abhishekam to": "Narasimha",
            "Abhishekam at": "Swathi day 6:30 pm"
        },
        {
            "Abhishekam to": "Rama",
            "Abhishekam at": "Punarvasu day 6:30 pm"
        },
        {
            "Abhishekam to": "Parvathi (Ambal / Abirami)",
            "Abhishekam at": "Friday 10:30 am"
        },
        {
            "Abhishekam to": "Maha Lakshmi",
            "Abhishekam at": "Friday 10:30 am"
        },
        {
            "Abhishekam to": "Boodevi",
            "Abhishekam at": "Friday 10:30 am"
        },
        {
            "Abhishekam to": "Dasabhuja Durga",
            "Abhishekam at": "Friday 10:30 am"
        },
        {
            "Abhishekam to": "Kanaka Durga",
            "Abhishekam at": "Sunday 4:30 pm"
        },
        {
            "Abhishekam to": "Anjaneya (Hanuman)",
            "Abhishekam at": "Saturday 3pm"
        },
        {	
            "Abhishekam to": "Garuda, Nagaraja & Dwara Ganapathi",
            "Abhishekam at": "Thursday 10:30 am"
        },
        {	
            "Abhishekam to": "Navagraha",
            "Abhishekam at": "Saturday 11 am"
        }
    ]

    const columnMapping = {
        "Abhishekam to": "Abhishekam to",
        "Abhishekam at": "Abhishekam at"
    }
    return (
        <>
            <div className={styles.AbishekaSponsorship}>
                <div className={styles.cardContainer}>
                    <div>
                        <Grid sx={{ marginTop: "10px" }}>
                            <Typography className={styles.typoGraphyHeading}>Annual Abhishekam Sponsorship Application</Typography>
                            <Typography className={styles.Content}>The following single payment ensures sponsorship of Religious services for one full year.</Typography>
                        </Grid>
                        <Grid sx={{ marginTop: "15px" }}>
                            <Typography className={styles.contentHeading}>All of the above services</Typography>
                        </Grid>
                        <Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <Typography className={styles.dollarContent}>$10,001.00</Typography>
                                <Typography className={styles.Content} >All temple sponsored festivals and Pujas, including weekly Abhishekas and Sevas (Muthangi, Poolangi, Tiruppavadai, Vajra Kireeta); One ï¿½at Homeï¿½ Puja of the devotee choice; One Satyanarayana Puja; Any one Kalyana Utsavam (Balaji/Shiva/Karthikeya); One Sahasra Nama Archana (for Birthday/Wedding Anniversary or any other day of choice).</Typography>
                            </Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <Typography className={styles.contentHeading}>Abhishekam to any 5 Deities once a week for a period of one year</Typography>
                                <Typography className={styles.dollarContent}>$5,001.00</Typography>
                            </Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <Typography className={styles.contentHeading}>Abhishekam to any 5 Deities once a week for a period of one year</Typography>
                                <Typography className={styles.dollarContent}>$3,001.00</Typography>
                            </Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <Typography className={styles.contentHeading}>Abhishekam to any 1 Deity once a week for a period of one year</Typography>
                                <Typography className={styles.dollarContent} >$1,116.00</Typography>
                            </Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <Typography className={styles.contentHeading}>Abhishekam to any 1 Deity once a month for a period of one year</Typography>
                                <Typography className={styles.dollarContent}>$301.00</Typography>
                            </Grid>
                            <Grid sx={{ marginTop: "15px" }}>
                                <GridTableComponent tableData={TableAbishekam} columnMapping={columnMapping} />
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AbishekaSponsorship;
